import "./useRedirect.css";

const useRedirect = () => {
  const redirect = (label, url, wait = 500) => {
    const body = document.getElementsByTagName("body")[0];
    if (body) {
      const background = document.createElement("div");
      background.classList.add("loading-background");

      const loading = document.createElement("div");
      loading.classList.add("loading");

      const img = document.createElement("img");
      img.src = "/redirect-loading.svg";
      img.classList.add("loading-icon");
      loading.appendChild(img);

      const p = document.createElement("h2");
      p.classList.add("header");
      const content = document.createTextNode("Omdirigerar till");
      p.appendChild(content);
      loading.appendChild(p);

      const site = document.createElement("h2");
      site.classList.add("title");
      const title = document.createTextNode(`${label}`);
      site.appendChild(title);
      loading.appendChild(site);

      background.appendChild(loading);

      body.appendChild(background);
    }

    setTimeout(() => {
      window.location = url;
    }, wait);
  };

  return { redirect };
};

export default useRedirect;
